module.exports = __webpack_public_path__ + "img/lyon.50d739b1.png";